import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../lib/api';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { if (!token) navigate('/passwort-vergessen', { replace: true }); }, [token, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password.length < 8) { toast.error(t('passwordReset.tooShort')); return; }
    if (password !== confirm) { toast.error(t('passwordReset.noMatch')); return; }
    setBusy(true);
    try {
      await api.post('/api/auth/reset-password', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2500);
    } catch (err) {
      toast.error(err.response?.data?.message || t('passwordReset.invalidToken'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="reset-password-page">
      <header className="px-8 py-6"><Logo/></header>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="so-card p-8 md:p-10 max-w-md w-full">
          <h1 className="text-2xl font-bold tracking-tight" data-testid="reset-title">{t('passwordReset.newTitle')}</h1>
          {done ? (
            <div className="mt-6 rounded-md border border-success/30 bg-success/5 p-4 text-sm" data-testid="reset-success">
              {t('passwordReset.successUpdated')}
              <div className="mt-4">
                <Link to="/login" className="so-btn so-btn-primary text-xs" data-testid="reset-go-login">{t('passwordReset.backToLogin')}</Link>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="reset-form">
              <div>
                <label className="so-label">{t('passwordReset.newPassword')}</label>
                <input
                  type="password"
                  required
                  minLength={8}
                  className="so-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password-input"
                />
                <p className="text-[11px] text-text-secondary mt-1">{t('passwordReset.minChars')}</p>
              </div>
              <div>
                <label className="so-label">{t('passwordReset.confirmPassword')}</label>
                <input
                  type="password"
                  required
                  minLength={8}
                  className="so-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input"
                />
              </div>
              <button type="submit" disabled={busy} className="so-btn so-btn-primary w-full" data-testid="reset-submit-btn">
                {busy ? t('passwordReset.saving') : t('passwordReset.setPassword')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
